import { CoreModule } from './core/core.module';
import { LogOutModule } from './log-out/log-out.module';
import { AuthErrorModule } from './auth-error/auth-error.module';

import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateModule } from '@angular/material/core';
import { MaterialsModule } from './shared/materials/materials.module';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { NgxGraphModule } from '@swimlane/ngx-graph';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { LayoutModule } from '@angular/cdk/layout';

import { APP_DATE_FORMATS, AppDateAdapter } from './core/date/date-helper';

import { DatePipe, TitleCasePipe } from '@angular/common';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { environment } from 'src/environments/environment';
import { SharedModule } from './shared/shared.module';
import { FinanceCurrencyInputComponent } from './learner/learner-attendance/learner-attendance-details/finance-currency-input/finance-currency-input.component';
import { LearnerAttendanceDetailsComponent } from './learner/learner-attendance/learner-attendance-details/learner-attendance-details.component';
import { DiscussionFormComponent } from './learner/learner-details/jobs-growth-wales-plus/discussion-form/discussion-form.component';
import { RequestRegistrationComponent } from './learner/learner-progress/objectives/request-registration/request-registration.component';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { ErrorInterceptorService } from './core/interceptors/error-interceptor.service';
import { PermissionsRequestFormComponent } from './staff/permissions-request-form/permissions-request-form.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AboutComponent } from './about/about.component';
import { RedirectComponent } from './redirect/redirect.component';
import { NoteDialogComponent } from './shared/components/note-dialog/note-dialog.component';
import { BdHomepageModule } from './bd-homepage/bd-homepage.module';
import { HsHomepageModule } from './hs-homepage/hs-homepage.module';
import { PartnerHomepageModule } from './partner-homepage/partner-homepage.module';

@NgModule({
  exports: [MaterialsModule, FormsModule, ReactiveFormsModule, FlexLayoutModule, LogOutModule, AuthErrorModule],
  declarations: [
    AppComponent,
    PermissionsRequestFormComponent,
    RequestRegistrationComponent,
    LearnerAttendanceDetailsComponent,
    DiscussionFormComponent,
    FinanceCurrencyInputComponent,
    ConfirmDialogComponent,
    RedirectComponent,
    PageNotFoundComponent,
    AboutComponent,
    NoteDialogComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    MaterialsModule,
    SharedModule,
    BrowserAnimationsModule,
    LayoutModule,
    NativeDateModule,
    NgxGraphModule,
    FlexLayoutModule,
    MatDialogModule,
    NgxDaterangepickerMd.forRoot(),
    CKEditorModule,
    NgSelectModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.clientId, // Application (client) ID from the app registration
          authority: `https://login.microsoftonline.com/${environment.tenantId}`,
          redirectUri: environment.redirectUri, // This is your redirect URI
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: false,
        },
      }),
      null,
      null
    ),
    BdHomepageModule,
    HsHomepageModule,
    PartnerHomepageModule,
  ],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: LOCALE_ID, useValue: 'en-GB' },
    TitleCasePipe,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
